import isNil from 'lodash/isNil';
import toString from 'lodash/toString';
import {
  EncounterVitalsRequestDTO,
  EncounterVitalsResponseDTO,
} from 'dtos';
import {
  isEmptyString,
} from '@populateui/utils';
import {
  DEFAULT_EMPTY_VALUE,
} from 'core/constants';
import {
  formatVitalNumber,
  vitalMetrics,
} from 'core/vitals/utils';
import {
  VitalsFormValues,
  VitalFieldKey,
} from 'pages/Dashboard/pages/Encounters/pages/List/components/PatientDetails/Vitals/types';

const vitalKeys = vitalMetrics.flatMap(({ series }) => series.map(({ key }) => key));

function mapVitalValues<T, U>(
  values: Partial<Record<VitalFieldKey, T | null>>,
  mapper: (value?: T | null) => U,
): Record<VitalFieldKey, U> {
  return Object.fromEntries(
    vitalKeys.map((key) => [key, mapper(values[key])]),
  ) as Record<VitalFieldKey, U>;
}

export function normalizeVitalsFormValues(vitalsResponse?: EncounterVitalsResponseDTO | null): VitalsFormValues {
  return mapVitalValues(vitalsResponse ?? {}, toString);
}

export function serializeVitals(
  encounterId: number,
  values: VitalsFormValues,
): EncounterVitalsRequestDTO {
  return {
    encounterId,
    ...mapVitalValues(values, (value) => {
      if (isEmptyString(value)) {
        return null;
      }

      const parsedValue = Number(value);
      return Number.isNaN(parsedValue) ? null : parsedValue;
    }),
  };
}

export function formatVitalDisplayValue(
  value?: number | null,
  key?: VitalFieldKey,
): string {
  return isNil(value) ? DEFAULT_EMPTY_VALUE : formatVitalNumber(value, key);
}
